export default __webpack_public_path__ + "static/Scroll-Image---Asphalt-Driveway-Removal-724d2f179ded7fc954469e66703b1837.jpg";